import { render } from "./ForecastExportMenu.vue?vue&type=template&id=bfb8b986"
import script from "./ForecastExportMenu.vue?vue&type=script&lang=js"
export * from "./ForecastExportMenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/antoniomarrazzo/Janus - Pasar/janus-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__